import { render, staticRenderFns } from "./neuralComputer.vue?vue&type=template&id=ad13772c&scoped=true"
import script from "./neuralComputer.vue?vue&type=script&lang=js"
export * from "./neuralComputer.vue?vue&type=script&lang=js"
import style0 from "./neuralComputer.vue?vue&type=style&index=0&id=ad13772c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad13772c",
  null
  
)

export default component.exports